import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface CheDoBaoCao {
  name: string;
  api_token: string;
}

export interface cheDoBaoCaoDetaiInfor {
  errors: unknown;
  CheDoBaoCao: CheDoBaoCao;
  isAuthenticated: boolean;
}

@Module
export default class CheDoBaoCaoDetail
  extends VuexModule
  implements cheDoBaoCaoDetaiInfor
{
  errors = {};
  CheDoBaoCao = {} as CheDoBaoCao;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get CheDoBaoCaoDetail() {
    return this.cheDoBaoCaoDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.CHEDO_BAOCAO_DETAIL_DATA](CheDoBaoCao) {
    this.cheDoBaoCaoDetailData = CheDoBaoCao;
  }
  @Action
  [Actions.CHEDO_BAOCAO_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/chedo_baocaos",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(Mutations.CHEDO_BAOCAO_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
